module.exports = __webpack_public_path__ + "img/esoseska_homepage_1.9c183461.png";